import { OrderDoc } from '@gooduncles/gu-app-schema';
import { Spin } from 'antd';
import { FC } from 'react';

import classes from './StoreSection.module.scss';

import RecentOrderCard from './RecentOrderCard';

interface RecentOrderListProps {
  orders: OrderDoc[];
  isLoading: boolean;
  selectedOrderId: string | null;
  onOrderSelect: (order: OrderDoc) => void;
}

const RecentOrderList: FC<RecentOrderListProps> = ({
  orders,
  isLoading,
  selectedOrderId,
  onOrderSelect,
}) => {
  if (isLoading) {
    return (
      <div className={classes.loadingWrapper}>
        <Spin size='small' />
      </div>
    );
  }

  if (orders.length === 0) {
    return <div className={classes.emptyMessage}>최근 주문이 없습니다</div>;
  }

  return (
    <div className={classes.orderList}>
      {orders.map((order) => (
        <RecentOrderCard
          key={order._id}
          order={order}
          isSelected={selectedOrderId === order._id}
          onSelect={() => onOrderSelect(order)}
        />
      ))}
    </div>
  );
};

export default RecentOrderList;
